import React from "react";
import { Momentum } from '@uiball/loaders'
import styles from "./TrackingStatus.module.scss";


// We want to apply green/red colours to good/bad statuses
// as well as appropriate icons.
export const TrackingStatus = (props) => {
  const {
    status,
  } = props;

  const classes = [
    styles.module,
  ];

  let inner = null;

  switch (status) {
    case "stopped":
    case "completed":
      classes.push(styles.positive);
      break;

    case "failed":
    case "exception":
      classes.push(styles.negative);
      break;
    
    default:
      classes.push(styles.inProgress)
      inner = <Momentum size={16} speed={1.1} color="black" />
      break;
  }

  return <div className={classes.join(" ")}>{inner}</div>
}